import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 3l1 6l2 -3.75l2 3.75l1 -6","key":"svg-0"}],["path",{"d":"M16 21l-4 -8l-4 8l4 -2l4 2","key":"svg-1"}]]

/**
 * IconNavigationWest
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbmF2aWdhdGlvbi13ZXN0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik05IDNsMSA2bDIgLTMuNzVsMiAzLjc1bDEgLTYiIC8+CiAgPHBhdGggZD0iTTE2IDIxbC00IC04bC00IDhsNCAtMmw0IDIiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/navigation-west
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconNavigationWest = createReactComponent('outline', 'navigation-west', 'NavigationWest', __iconNode);

export default IconNavigationWest;